import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import IndexView from '@/views/IndexView.vue'
import LoadView from '@/views/LoadView.vue'
import WorksMian from '@/views/main/WorksMian.vue'
import WorkComments from '@/views/main/WorkComments.vue'
import TeacherMain from '@/views/main/TeacherMian.vue'
import UploadMian from '@/views/main/UploadMian.vue'
import InformationMian from '@/views/main/InformationMian.vue'
import CoursesMian from '@/views/main/CoursesMian.vue'
import ClassesMian from '@/views/main/ClassesMian.vue'
import WorksUser from '@/views/main/WorksUser.vue'
import { getToseck } from '@/utils/toseck'
import store from '../store';
import { Message } from 'element-ui';
import MajorsMian from '@/views/main/MajorsMian.vue'
import UserMian from '@/views/main/UserMian.vue'
import NotFound from '@/views/404/NotFound.vue'
import OmdAboutUs from '@/views/main/OmdAboutUs.vue'
import CreditRules from '@/views/main/system/rules/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoadView
  },
  {
    path: '/home',
    name: 'home',
    component: HomePage,
    meta: { requiresAuth: true } // 可根据需要添加验证
  },
  {
    path: '/index',
    name: 'index',
    component: IndexView,
    meta: { requiresAuth: true }
  },
  {
    path: '/works',
    name: 'works',
    component: WorksMian,
    meta: { requiresAuth: true }
  },
  {
    path: '/workcomm',
    name: 'workcomm',
    component: WorkComments,
    meta: { requiresAuth: false }
  },
  {
    path: '/upload',
    name: 'upload',
    component: UploadMian,
    meta: { requiresAuth: true }
  },
  {
    path: '/teacher',
    name: 'teacher',
    component: TeacherMain,
    meta: { requiresAuth: true }
  },
  {
    path: '/inform',
    name: 'inform',
    component: InformationMian,
    meta: { requiresAuth: true }
  },
  {
    path: '/courses',
    name: 'courses',
    component: CoursesMian,
    meta: { requiresAuth: true }
  },
  {
    path: '/majors',
    name: 'majors',
    component: MajorsMian,
    meta: { requiresAuth: true }
  },
  // {
  //   path: '/',
  //   name: 'collection',
  //   component: CollectionMian,

  // }, //这是原来的主页
   {
    path: '/',
    redirect:'/login',

  }, 
  {
    path: '/classe',
    name: 'classe',
    component: ClassesMian,
    meta: { requiresAuth: true }
  },
  {
    path:'/worksuser',
    name:'worksuser',
    component:WorksUser,
    meta: { requiresAuth: true }
  },
  {
    path:'/creditrules',
    name:'creditrules',
    component:CreditRules,
    meta: { requiresAuth: true }
  },
  
  {
    path: '/users',
    name: 'users',
    component:UserMian,
    meta: { requiresAuth: true }
  },
  {
    path:'/useran',
    name:'useran',
    component:UserMian,
    meta: { requiresAuth: true  }
  },
  {
    path:'/omd',
    name:'omd',
    component:OmdAboutUs,
  },
  {
    path:'*',
    name:'404',
    component:NotFound
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = getToseck();
    const user = sessionStorage.getItem('identity');
    const isTokenExpired = token && token.exp && token.exp < Date.now() / 1000;
    if(to.name==='login'){
       next()
    }
    if (!token || !isTokenExpired) {
      if (!user) {
        Message.warning('请先登录');
        next('/login');
      }
      else {
        if(isTokenExpired){
         Message.warning('登录过期，请重新登录');
         next('/login'); 
        }else{
          store.commit('page/setPage', token.name);
          next();
        } 
      }
    }else {
      next(); 
    }
  } else {
    next();
  }
})


export default router
